export default __webpack_public_path__ + "assets/images/cf0f76e6a7c4d2fa5834ac454c3a8c6e.png";